/**
 * @typedef {Object} CatalogueCourseTeacherModel
 * @property {string} fullName
 * @property {number} personId
 * @property {string} personPictureUrl
 * @property {boolean} isContactPersonInCatalogue
 *
 * @typedef {Object} AntiForgery
 * @property {string} antiForgeryHeaderName
 * @property {string} antiForgeryHeaderValue
 *
 * @typedef {Object} SiteList
 * @property Site[] EntityArray
 *
 * @typedef {Object} Site
 * @property {number} CustomerId
 * @property {string} Title
 */

import { get, post } from '@itslearning/atlas/network/fetch';

/**
 * Get organisations
 * @param {string} searchText
 * @returns {Promise<SiteList>} The result of the request
 */
 export const getOrganisations = (searchText) => {
     return get(`/restapi/sites/all/organisations/search/v1?searchText=${searchText}`);
 };
